import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SelectedActivity } from '@/lib/storage';

interface SortableActivityItemProps {
  activity: SelectedActivity;
  index: number;
  onRemove: (index: number) => void;
}

export const SortableActivityItem = ({ activity, index, onRemove }: SortableActivityItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: activity.id.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const getMonthLabel = (index: number) => {
    switch (index) {
      case 0: return "1er mois";
      case 1: return "2ème mois";
      case 2: return "3ème mois";
      case 3: return "4ème mois";
      case 4: return "5ème mois";
      case 5: return "6ème mois";
      default: return `${index + 1}ème mois`;
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`bg-primary-light/10 p-3 rounded border-l-4 border-primary-light flex items-center gap-3 ${
        isDragging ? 'opacity-50' : ''
      }`}
    >
      <div
        {...attributes}
        {...listeners}
        className="cursor-grab active:cursor-grabbing text-muted-foreground hover:text-foreground"
      >
        <GripVertical className="w-4 h-4" />
      </div>
      
      {/* Affichage de la photo personnalisée pour le puzzle */}
      {activity.id === 1 && activity.customPhotoUrl && (
        <div className="w-10 h-10 rounded-md overflow-hidden bg-muted flex-shrink-0">
          <img
            src={activity.customPhotoUrl}
            alt="Photo personnalisée"
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      <div className="flex-shrink-0 min-w-[80px]">
        <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded">
          {getMonthLabel(index)}
        </span>
      </div>
      
      <div className="flex-1">
        <div className="font-medium text-sm">{activity.name}</div>
        <div className="text-xs text-muted-foreground">{activity.category}</div>
        {activity.id === 1 && activity.customPhotoUrl && (
          <div className="text-xs text-primary mt-1">Photo personnalisée ajoutée</div>
        )}
      </div>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onRemove(index)}
        className="text-red-500 hover:text-red-700 hover:bg-red-50 p-1 h-auto"
      >
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
};